import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import FormInputTextField from 'components/FormInputTextField/FormInputTextField.vue'

export default {
    name: "WebshopPaymentSelector",
    components: { FormInputTextField },
    props: {},
    setup() {
        const paymentOptions = {
            "private": [
                'mobilepay',
                'creditcard'
            ],
            "company": [
                'mobilepay',
                'creditcard'
            ],
            "publicInstitution": [
                'mobilepay',
                'creditcard',
                'betalingsservice'
            ],
            "frivillige": [
                'betalingsservice'
            ]
        }
        
        const store = useStore()
        const unSubmitted = ref(true)
        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'webshopPaymentSelector', labelKey: labelKey })
        const paymentType = computed(()=> store.state.checkout.purchaseData.invoice.userInformation.customerType)
        const paymentMethodInState = computed(()=> store.state.checkout.stepThree.paymentData.paymentMethod)

        const setPaymentTypeOnEnter = function(e){
            const option = e.target.getAttribute('for')
            const radio = document.getElementById(option)
            paymentMethod.value = +radio.value
            commitPaymentInputToStore()
        }
        
        // in order to re-select first option on first visit to paymentSelector 
        const paymentMethod = ref(paymentMethodInState.value ? paymentMethodInState.value : 1)
        const paymentMethodFilled = computed(() => {
            return unSubmitted.value ? false : !!paymentMethod.value > 0
        })

        const updateActivePaymentMethod = () => {
            // updating the active payment method to stepThree in state
            // in order to apply active step styles 
            if(paymentMethodFilled.value ) {
                store.commit('checkout/set_active_payment_method', paymentMethod.value)
            }
        }

        const commitPaymentInputToStore = () => {
            updateActivePaymentMethod()
            unSubmitted.value = false
            let isAllValid = paymentMethodFilled.value

            store.commit('checkout/set_payment_data_validation_success', paymentMethodFilled.value)

            if(isAllValid){
                const paymentPayload = { paymentMethod: paymentMethod.value }
                store.commit('checkout/set_payment_data', paymentPayload)
            }
        }
    
        const determineActivePaymentMethod = function(currentPaymentMethod) {
            // if nothing in state yet, give styles to clicked method
            // concious choice with '==', as we need to compare string and number
            if(!paymentMethodInState.value) {
                return currentPaymentMethod == paymentMethod.value ? true : false
            } else {
                return currentPaymentMethod == paymentMethodInState.value ? true : false
            }
        }

        onMounted(() => {
            // Update store with data initially set in this component
            commitPaymentInputToStore()
        })

        return {
            paymentMethod,
            paymentMethodFilled,
            paymentOptions,
            paymentType,
            unSubmitted,
            setPaymentTypeOnEnter,
            commitPaymentInputToStore,
            determineActivePaymentMethod,
            getLabel,
        }
    }
}